import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import IconBack from '@material-ui/icons/ArrowBack'
import IconButton from '@material-ui/core/IconButton'
import {
  Input,
  Tooltip,
  InputAdornment,
  FormControl,
  CircularProgress,
  makeStyles
} from '@material-ui/core'
import IconSearch from '@material-ui/icons/Search'

import { useLiterals } from '~/components/Literals'
import { selectSearchField } from '~/selectors'
import actions from '~/actions'
import track from '~/track'

const useStyles = makeStyles(() => ({
  root: { width: '100%', margin: 0 },
  loader: { position: 'absolute', right: -2 }
}))

function SearchField({ isHome, className, position }) {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const { getLiteral } = useLiterals()
  const { placeholder = getLiteral('1501'), canBack, q, loading } = useSelector(selectSearchField)

  const [inputValue, setValue] = useState(q || '')
  const inputRef = useRef()

  useEffect(() => {
    if (!isHome) setValue(q || '')
  }, [q])

  useEffect(() => {
    if (isHome) setValue('')
  }, [isHome])

  const handleBack = () => {
    dispatch(
      actions.updateApp({
        searchFor: null
      })
    )

    history.push('/')
  }

  const handleSubmit = (e) => {
    const cleanInput = inputValue.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]]/gi, '')
    console.log('🔎 Search term ~', cleanInput)

    const search = () => {
      if (isHome) {
        track('busca', { category: 'home', name: cleanInput })
      } else {
        track('buscaProduto', { category: 'menu', name: cleanInput })
      }

      inputRef.current.blur()
      history.push(`/busca?q=${cleanInput}`)
    }

    e.preventDefault()

    if (!loading && cleanInput && cleanInput.length > 2) {
      if (position.user?.lat && position.user?.lng) {
        search()
      } else {
        position.handleShowPositionDialog(true)
      }
    }
  }

  const handleChange = (e) => setValue(e.target.value)

  return (
    <form onSubmit={handleSubmit} className={classes.root}>
      <FormControl fullWidth className={className}>
        <Input
          id="gofind-search"
          type="text"
          placeholder={placeholder}
          value={inputValue}
          disableUnderline
          inputRef={inputRef}
          fullWidth
          autoComplete="off"
          onChange={handleChange}
          aria-label={placeholder}
          startAdornment={
            canBack &&
            !isHome && (
              <InputAdornment position="start">
                <Tooltip
                  title={getLiteral('1051')}
                  PopperProps={{
                    container: document.getElementById('gofind-finder') || document.body
                  }}
                >
                  <span>
                    <IconButton
                      size="small"
                      aria-label={getLiteral('1051')}
                      onClick={handleBack}
                      disabled={loading}
                      color="primary"
                      id="button-search-back"
                    >
                      <IconBack color="inherit" />
                    </IconButton>
                  </span>
                </Tooltip>
              </InputAdornment>
            )
          }
          endAdornment={
            <InputAdornment position="end">
              <Tooltip
                title={getLiteral('2029')}
                PopperProps={{
                  container: document.getElementById('gofind-finder') || document.body
                }}
              >
                <span>
                  <IconButton
                    size="small"
                    aria-label={getLiteral('2029')}
                    disabled={loading || !inputValue || inputValue.length < 3}
                    color="primary"
                    onClick={handleSubmit}
                    style={{ marginRight: 8 }}
                  >
                    <IconSearch color="inherit" />
                    {loading && (
                      <CircularProgress className={classes.loader} size={35} color="primary" />
                    )}
                  </IconButton>
                </span>
              </Tooltip>
            </InputAdornment>
          }
        />
      </FormControl>
    </form>
  )
}

export default SearchField
